/** localStorage keys used to persist Plaid OAuth state across browser redirects */
export const PLAID_TOKEN_KEY = 'plaid_link_token'
export const PLAID_FACILITY_KEY = 'plaid_oauth_facility_id'
export const PLAID_ORG_KEY = 'plaid_oauth_org_id'
/** When set to 'true', the OAuth callback should call complete-update instead of exchange-token */
export const PLAID_UPDATE_MODE_KEY = 'plaid_oauth_update_mode'
/** The plaid_items.id being reconnected (only set in update mode) */
export const PLAID_ITEM_ID_KEY = 'plaid_oauth_item_id'

/** Remove all Plaid OAuth state from localStorage */
export function clearPlaidOAuthState(): void {
  localStorage.removeItem(PLAID_TOKEN_KEY)
  localStorage.removeItem(PLAID_FACILITY_KEY)
  localStorage.removeItem(PLAID_ORG_KEY)
  localStorage.removeItem(PLAID_UPDATE_MODE_KEY)
  localStorage.removeItem(PLAID_ITEM_ID_KEY)
}
